import { createStyles, getStylesRef } from "@mantine/core"

export const useStyles = createStyles((theme, { disabled }: { disabled: boolean }) => ({
    actionIcon: {
        borderRadius: "2rem",
        color: theme.colors.gray[7],
        cursor: "pointer",
        height: "2.5rem",
        width: "2.5rem",

        "&:disabled": {
            backgroundColor: theme.colors.gray[0],
            color: theme.colors.gray[4],
            cursor: "unset",
        },

        "&:hover": {
            backgroundColor: theme.colors.violet[1],
            color: theme.colors.violet[7],
        },
    },
    badge: {
        backgroundColor: theme.colors.gray[1],
        borderRadius: "2rem",
        color: theme.colors.gray[7],
        fontSize: "14px",
        height: "2rem",
        padding: "0 4px 0 12px",
        textTransform: "none",

        ".mantine-Badge-rightSection": {
            marginLeft: 0,
        },
    },
    badgeContainer: {
        marginTop: "0.5rem",
    },
    error: {
        color: theme.colors.red[6],
        fontSize: theme.fontSizes.xs,
        marginTop: "0.5rem",
    },
    wrapper: {
        [`&:focus-within .${getStylesRef("actionIcon")}`]: {
            borderColor: theme.colors.primary[8],
        },
    },
    label: {
        fontSize: ".875rem",
        fontWeight: 500,
        color: theme.colors.gray[7],
        marginBottom: 0,
    },
    input: {
        width: "100%",
    },
}))
